import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";

const   ChannelPendingModal = ({ open, setOpen  }) => {
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Channel Pending</div>


        <div className="lg:text-[14px] text-[13px] text-center">
        This should only take a moment. We’re waiting for confirmation from Front that the integration was successful. You can refresh your channels tab for an up to date status.
        </div>


     


        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'rgba(96,91,255,1)',
                    color: "white",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1.5px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    
                    setOpen(false)
                  }}
                >
                  Okay
                </Button>
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default  ChannelPendingModal;
